import request from '@/utils/request'
  export function index(id) {
    return request({
      url: `/assent/penalties/${id}`,
      method: 'get',
    })
  }

